export default import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg_22b9aca69a5bb724e9014f39